import { render, staticRenderFns } from "./pt-radio-list.vue?vue&type=template&id=9718b492"
import script from "./pt-radio-list.vue?vue&type=script&lang=js"
export * from "./pt-radio-list.vue?vue&type=script&lang=js"
import style0 from "./pt-radio-list.vue?vue&type=style&index=0&id=9718b492&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports